import React, { useState } from "react";

const SideNavButton = () => {

    const [isSideBarOpen, setIsSideBarOpen] = useState(true);

    const handleSideNav = () => {

        const wrapper = document.getElementById("wrapper");

        if (isSideBarOpen) {

            setIsSideBarOpen(false);

            document.body.classList.add('enlarged');
            document.body.classList.remove('sidebar-enable');

            // ✅ content resize
            if(wrapper){
                wrapper.classList.add("toggled");
            }

        } 
        else {

            setIsSideBarOpen(true);

            document.body.classList.add('sidebar-enable');
            document.body.classList.remove('enlarged');

            // ✅ content normal
            if(wrapper){
                wrapper.classList.remove("toggled");
            }

        }
    }

    return (
        <li>
            <button 
                className="button-menu-mobile waves-effect waves-light"
                onClick={handleSideNav}
            >
                <i className="fe-menu"></i>
            </button>
        </li>
    )
}

export default SideNavButton;